export const callMethod = (method, arg) => {
  try {
    // eslint-disable-next-line no-eval
    eval(method)(arg);
  } catch (err) {
    // Do Nothing
  }
};

// The hosted controls script will emit a message when specific events occur within the iframe.
// The message data can contain "functionCall ${functionName}" or "${functionName} ${args}".
// We can implement our own functions with the same names in js to react to specific events within the iframe.
export const parseFsMessage = (e) => {
  const message = e.data;
  // Fullsteam js url is a string with additional segments. Need to just check the origin of the full url string.
  // e.g. https://hostedpayments-ext.fullsteampay.net/js/hostedcontrols/2.0.0/fullsteam.hostedcontrols.js
  if (process.env.REACT_APP_FULLSTEAM_JS_URL.includes(e.origin) && message.split) {
    const messageSplit = message.split(' ');

    if (messageSplit[0] === 'functionCall') {
      const functionName = messageSplit[1];
      const argument = messageSplit[2];
      return [functionName, argument];
    }

    const functionName = messageSplit[0];
    const argument = messageSplit[1];
    return [functionName, argument];
  }
  return [];
};
